import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { PlanbookUI } from "@shared/models/analytics/planbook"
import type { PreparedAction } from "../../action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "../create-narrative"
import defaultPlanbookContext from "../planbook/default-planbook-context"
import defaultPlanbookModels from "../planbook/default-planbook-models"

interface Payload {
  planbookId: string
  noun: PlanbookUI["primary_object_specifier"]
  verb: PlanbookUI["primary_verb"]
}

export default function planbookUIAction(payload: Payload): PreparedAction {
  return {
    name: "PLANBOOK_UI_ACTION",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, findFn: FindFn, userId: string): Narrative {
  let models = defaultPlanbookModels(payload, findFn, userId, payload.planbookId)
  let newEvent: PlanbookUI = {
    ...createBlankEvent(),
    root_id: payload.planbookId,
    root_type: "planbook",
    date_plan_scheduled_for: null,

    primary_verb: payload.verb,
    primary_possessive: "owns",

    primary_object_type: "planbook",
    primary_object_id: payload.planbookId,
    primary_object_specifier: payload.noun,
    primary_object_id_and_ancestor_ids: [payload.planbookId],

    adverbial_verb: null,

    adverbial_object_type: null,
    adverbial_object_id: null,
    adverbial_object_specifier: null,
    adverbial_object_id_and_ancestor_ids: null,
  }

  return {
    title: `User ${payload.verb}s ${payload.noun}`,
    titleForAnalytics: "Planbook - Interaction",
    description: `User ${payload.verb}ed the ${payload.noun}`,
    context: {
      ...defaultPlanbookContext(payload, models),
      noun: payload.noun,
      verb: payload.verb,
    },
    activity: {},
    newAnalyticsEvents: [newEvent],
  }
}
